import { Box, Divider } from "@mui/material";
import ThemeContext from "components/app/Context";
import Export from "components/common/Export";
import { exportURLs } from "components/common/Export/ExportAPIEndpoints";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import SearchAppBar from "components/common/searchBar";
import BasicTable from "components/common/Table";
import Toggle from "components/common/Toggle";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { buildQueryString } from "services/ServiceHelper";
import { tokens } from "styles/Tokens";
import { PAGE_SIZE } from "utils/CommonConstants";
import { formFilterRequestPayload } from "utils/CommonFunctions";
import { serviceTypes } from "utils/Types";
import { fetchUnImplementedProperties } from "../../AboveProperty.slice";
import "./index.scss";
import { InProgressHeader } from "./TableHeadersConfig";

interface Props {
  toggleOn?: boolean;
  handleToggle: any;
  cmsId: any;
}

function UnImplementedProperties(props: Readonly<Props>) {
  const { handleToggle, toggleOn, cmsId } = props;

  const dispatch = useAppDispatch();
  const [pageNo, setPageNo] = useState(0);
  const { unImplementedProperties, unImplemenetedCount } = useAppSelector((state) => state.aboveProperty.planProgress);
  const location = useLocation();
  const { isMobileScreen } = useContext(ThemeContext);

  const pageName = filterPage.planProgressUnimplementedFromPlansDisplay;

  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[pageName]);

  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];

  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload);
  const searchText = globalFiltersforPage?.searchText ?? "";
  const planProgressSummary: any = useAppSelector((state) => state.aboveProperty.planProgressSummary);
  const planDetails = planProgressSummary;
  const { brandCodes, regions, ...otherFilters } = formattedFilterRequestPayload;

  const payload: any = {
    searchedPropertyText: searchText,
    ...otherFilters,
    ...(brandCodes?.length ? { brandCodes: brandCodes.join("::") } : {}),
    ...(regions?.length ? { regions: regions.join("::") } : {}),
    innCode: formattedFilterRequestPayload["innCode"] ?? location?.state?.progressInncodes?.join(", "),
    size: PAGE_SIZE,
    page: pageNo,
    cmsId: cmsId
  };

  const apiCall = () => {
    if (!toggleOn) dispatch(fetchUnImplementedProperties(payload));
  };

  useEffect(() => {
    if (pageNo === 0) {
      apiCall();
    }
  }, [pageNo, searchText, filterRequestPayload]);

  useEffect(() => {
    setPageNo(0);
  }, [searchText, filterRequestPayload]);

  useEffect(() => {
    if (pageNo > 0) {
      apiCall();
    }
  }, [pageNo]);

  return (
    <>
      <Box sx={{ padding: "16px 8px" }}>
        <Box className="filter-searchbar-wrapper ">
          <SearchAppBar
            isPreDefinedNav={true}
            value={searchText}
            placeholder="Search by Property"
            sx={{
              minWidth: isMobileScreen ? "initial" : "350px",
              border: `solid 1px ${tokens.Border.General.Tertiary}`
            }}
            getInputDetails={(val) =>
              dispatch(
                setPageFilter({
                  pageName: pageName,
                  searchText: val
                })
              )
            }
          />

          <Box className="toggle-filters">
            <Toggle
              onChange={(val: boolean) => handleToggle(val)}
              isToggleEnabled={false}
              isLabelLeftSide={true}
              sx={{ marginTop: "4px", marginLeft: isMobileScreen ? "8px" : "20px" }}
            />

            <GlobalFilters page={pageName} />
          </Box>
        </Box>
        <GlobalFilterDescription page={pageName} bgColor={tokens.Background.General.Primary} />
        <div className="export">
          <Export
            isGet
            URL={`${exportURLs.aboveProperty_unimplementedProperties}?${buildQueryString({
              innCodeFilterApplied: !!formattedFilterRequestPayload["innCode"]?.length,
              planName: planDetails?.name,
              ...payload
            })}`}
            serviceType={serviceTypes.userplan}
          />
        </div>
      </Box>

      <Divider />
      <BasicTable
        id="tableDiv"
        totalRecords={unImplemenetedCount}
        pagination={{ pageNo: pageNo, setPageNo: setPageNo }}
        data={{
          headers: InProgressHeader,
          rows: unImplementedProperties?.map((element: any) => {
            return {
              data: [
                {
                  content: element?.propertyName
                },
                { content: element?.innCode },
                { content: "-" },
                { content: "-" },
                { content: "-" },
                { content: "-" },
                { content: "-" },
                { content: "-" }
              ]
            };
          })
        }}
      />
    </>
  );
}

export default UnImplementedProperties;
